import { store } from './index'
import { authStorage } from './index'
import { createLogoutAction } from '../havainnot/auth/store/authActions';

export const effectMiddleware = (next: any) => (effect: any) => {
    const { type, payload } = effect

    if (type === 'PUT'
        && payload.action.payload
        && payload.action.payload.error
        && payload.action.payload.error.error
        && (
            payload.action.payload.error.error.message === "invalid_sid"
            || payload.action.payload.error.error.code === "SID ei ole voimassa"
        )
    ) {
        // Handle invalid SID from first response giving this error
        store.dispatch(createLogoutAction())
        authStorage.clearAuthFromStorage()
    }

    return next(effect);
};


export default effectMiddleware;
